import React from 'react'

const Background = ({children}) => {
  return (
    <div className='products'>
      {children}
    </div>
  )
}

export default Background
